import { FC } from "react";
import { createPortal } from "react-dom";
import { FechamentoCaixaForm } from "./FechamentoCaixaForm";
import "../styles/caixa.css";

interface Props {
  show: boolean;
  onClose: () => void;
  onClosed: () => void;
}

export const FecharCaixaModal: FC<Props> = ({ show, onClose, onClosed }) => {
  if (!show || typeof document === "undefined") return null;

  return createPortal(
    <>
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        style={{ zIndex: 1055 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold">Fechar Caixa</h3>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={onClose}
              />
            </div>
            <div className="modal-body caixa-module">
              <p className="text-muted fs-7 mb-5">
                Confira o saldo e informe o valor contado para fechar o caixa.
              </p>
              <FechamentoCaixaForm
                onSuccess={() => {
                  onClosed();
                  onClose();
                }}
                onCancel={onClose}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
    </>,
    document.body,
  );
};
